<!---
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzRequired nzFor="art">{{ model.Propertys.ART.title}}</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="ArtErrorTip">
      <ng-template #ArtErrorTip let-control>
        <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.ART.hint }}</ng-container>
        <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
        <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
      </ng-template>
      <input nz-input formControlName="art" id="art" [placeholder]="model.Propertys.ART.placeholder" cdkFocusInitial/>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzRequired nzFor="inhalt">{{ model.Propertys.INHALT.title}}</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="InhaltErrorTip">
      <ng-template #InhaltErrorTip let-control>
        <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.INHALT.hint }}</ng-container>
        <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
        <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
      </ng-template>
      <input nz-input formControlName="inhalt" id="inhalt" [placeholder]="model.Propertys.INHALT.placeholder"/>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="kommentar">{{ model.Propertys.KOMMENTAR.title}}</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="KommentarErrorTip">
      <ng-template #KommentarErrorTip let-control>
        <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.KOMMENTAR.hint }}</ng-container>
        <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
        <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
      </ng-template>
      <textarea nz-input formControlName="kommentar" id="kommentar" [placeholder]="model.Propertys.KOMMENTAR.placeholder"></textarea>
    </nz-form-control>
  </nz-form-item>
 -->
<nz-spin [nzSpinning]="$loading | async">
  <form nz-form [formGroup]="form" (ngSubmit)="submit()">
    <div formGroupName="konstante">
      <input class="cdk-visually-hidden" formControlName="id" id="id"/>
<!--- << content    -->
      <nz-form-item style="width: 100%;">
        <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzRequired nzFor="art">{{ model.Propertys.ART.title}}</nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="ArtErrorTip">
          <ng-template #ArtErrorTip let-control>
            <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.ART.hint }}</ng-container>
            <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
            <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
          </ng-template>
          <input nz-input formControlName="art" id="art" [placeholder]="model.Propertys.ART.placeholder" cdkFocusInitial/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item style="width: 100%;">
        <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzRequired nzFor="inhalt">{{ model.Propertys.INHALT.title}}</nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="InhaltErrorTip">
          <ng-template #InhaltErrorTip let-control>
            <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.INHALT.hint }}</ng-container>
            <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
            <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
          </ng-template>
          <input nz-input formControlName="inhalt" id="inhalt" [placeholder]="model.Propertys.INHALT.placeholder"/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item style="width: 100%;">
        <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="kommentar">{{ model.Propertys.KOMMENTAR.title}}</nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="KommentarErrorTip">
          <ng-template #KommentarErrorTip let-control>
            <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.KOMMENTAR.hint }}</ng-container>
            <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
            <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
          </ng-template>
          <textarea nz-input formControlName="kommentar" id="kommentar" [placeholder]="model.Propertys.KOMMENTAR.placeholder"></textarea>
        </nz-form-control>
      </nz-form-item>
<!---    content >> -->
      <nz-form-item>
        <nz-form-control [nzOffset]="16">
          <button nz-button nzType="primary" type="submit" [nzLoading]="$loading | async" [disabled]="!form.valid || ($loading | async)">
            <i nz-icon nzType="check-circle" nzTheme="outline"></i>
            Speichern
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </form>
<!--- << extra    -->
<!---    extra >> -->
</nz-spin>
